module.exports = __webpack_public_path__ + "f80f7e630a12463ae8c81308e6ba75a2.svg";